import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMembersSantamembersSantaMembersUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/santa-members',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    _: [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/members/v1/santa-members',
        destPath: '/v1/santa-members',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_members-area_santa-member';

/** Returns my member page */
export function getMyMemberPage(payload: object): RequestOptionsFactory<any> {
  function __getMyMemberPage({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v1.santa_member',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.members.santamembers.SantaMembers.GetMyMemberPage',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMembersSantamembersSantaMembersUrl({
        protoPath: '/v1/santa-members/my/page',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getMyMemberPage;
}

/**
 * Returns site map
 * No permission as the request can be made by anything pretty much
 */
export function getSiteMap(payload: object): RequestOptionsFactory<any> {
  function __getSiteMap({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v1.santa_member',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.members.santamembers.SantaMembers.GetSiteMap',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMembersSantamembersSantaMembersUrl({
        protoPath: '/v1/santa-members/sitemap',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getSiteMap;
}
